import React from 'react';
import { Navigate } from 'react-router-dom/dist';
import { useSelector } from 'react-redux';


const PrivateRoute = ({ children }) => {
    const user = useSelector(state => state.user)

    if (user && user.isLoading) {
        return null;
    }

    return user && user.isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default PrivateRoute;
